
// requiring html templates so that hot reloading works
const template = require('./dateTimeButton.html');

const NS = 'DateTimeButton'; // jshint ignore:line

export default function DateTimeButton($rootScope) { // as dateTimeButton
  "ngInject";

  return {
    controller: function () {
    },
    template,
    link,
    restrict: 'E',
    scope: {
      mode: '=',
      maxDate: '=',
      scopeObj: '=',
      property: '=',
      tooltip: '='
    }
  };

  function link(scope) {
    scope.displayMode = 'calendar-clock';
    if (scope.mode === 'time') {
      scope.displayMode = 'clock';
    }
    if (scope.mode === 'date') {
      scope.displayMode = 'calendar';
    }
    scope.openDateTimePicker = function (evt) {
      $rootScope.$broadcast('open-date-time-picker', evt, scope.scopeObj, scope.property, scope.mode, scope.maxDate);
    };
  }
}
